const calmTips = [
  {
    icon: "ri-sun-line",
    title: "Let in soft light",
    desc: "Sheer linen curtains filter harsh sunlight into a warm, even glow.",
  },
  {
    icon: "ri-layout-line",
    title: "Leave space to breathe",
    desc: "Empty corners and clear surfaces give the eye a place to rest.",
  },
  {
    icon: "ri-leaf-line",
    title: "Add one natural element",
    desc: "A single branch, ceramic, or dried stem anchors a room quietly.",
  },
  {
    icon: "ri-palette-line",
    title: "Stay within the palette",
    desc: "Fewer colors used deeply feel richer than many used once.",
  },
];

export default function SGCalmRoomSection() {
  return (
    <section className="py-28 px-8 md:px-16 max-w-screen-xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        {/* Image — left */}
        <div className="relative order-2 lg:order-1">
          <div className="rounded-2xl overflow-hidden aspect-[4/5] bg-[#F5F1E8]">
            <img
              src="https://public.readdy.ai/ai/img_res/2ebcf87c164699f6bef98fab53ec6265.jpg"
              alt="How to create a calm room feeling"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Pull quote overlay */}
          <div className="absolute bottom-8 left-8 right-8 bg-[#FAF7F0]/92 rounded-xl p-6">
            <p
              className="text-[#2C2825] text-base md:text-lg leading-relaxed italic text-center"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              "A room should feel like a pause, not a performance."
            </p>
          </div>
        </div>

        {/* Text — right */}
        <div className="order-1 lg:order-2">
          <div className="flex items-center gap-3 mb-7">
            <span
              className="text-[#D9CEBC] text-6xl leading-none"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700 }}
            >
              03
            </span>
            <span className="flex-1 h-px bg-[#EDE6DA]" />
          </div>

          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Calm Atmosphere
          </p>

          <h2
            className="text-[#2C2825] text-3xl md:text-4xl leading-snug mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            How to Create a<br />
            <em>Calm Room Feeling</em>
          </h2>

          <p
            className="text-[#6B5E53] text-base leading-relaxed mb-10 max-w-sm"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Simple ways to use light, layout, and materials to make a room feel more peaceful.
            Calm is not a style — it is a decision made room by room.
          </p>

          {/* Tip cards */}
          <div className="grid grid-cols-1 gap-4 mb-10">
            {calmTips.map((tip) => (
              <div
                key={tip.title}
                className="flex items-start gap-5 p-5 rounded-xl bg-[#F5F1E8]"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EDE6DA] flex-shrink-0">
                  <i className={`${tip.icon} text-[#8B8378] text-base`} />
                </div>
                <div>
                  <h4
                    className="text-[#2C2825] text-sm mb-1"
                    style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500 }}
                  >
                    {tip.title}
                  </h4>
                  <p
                    className="text-[#8B8378] text-xs leading-relaxed"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {tip.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <button
            className="inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-7 py-3 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Read Calm Styling Tips
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-line text-[10px]" />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}
